
export const OfferMenuEnum = {
    NewOffers: 0,
    Campaign: 1,
    FreeSpins: 2,
    Bonuses: 3,
    ReferFriend: 4,
    PromoCodes: 5,
    TournamentHistory: 6,
    SportTournaments: 7,
    BonusHistory: 8,
    PrizesHistory: 9,
}

export const OfferMenuEnumMobile = {
    Bonuses: 0,
    PromoCodes: 1,
}

Object.freeze(OfferMenuEnum);


export default OfferMenuEnum;